export default "/assets/icons/m30.png"